export class SegmentsMemoryStorage {
    constructor(settings) {
        this.settings = settings;
        this.segments = [];
    }
    storeSegment(segment) {
        var _a;
        this.segments.push(segment);
        const limitCount = ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.cachedSegmentsCount) || 30;
        if (this.segments.length > limitCount) {
            this.segments.shift();
        }
    }
    getSegments() {
        return this.segments;
    }
    getSegment(id) {
        return this.segments.find((segment) => segment.id === id);
    }
    destroy() {
        this.segments = [];
    }
}
